<template>
	<div>
		<vue-headful
	        title="Coberturas"
	        description="Conocé todas las prepagas y obras sociales que atendemos en VARELAB. Te recordamos que todas las órdenes médicas tienen una válidez de 30 días."
    	/>
		<div class="front front--page">
			<div v-parallax="0.1" v-parallax.centerX class="bg-parallax bg-parallax--coberturas"></div>
			<div class="container">
				<h1 class="title title--big color--white">Coberturas</h1>
				<div class="separator separator--white"></div>
			</div>
		</div>

		<div class="page-body">
			<div class="container">
				<h2 class="color--light-blue">Conocé todas las prepagas y obras sociales que atendemos en VARELAB. Te recordamos que todas las órdenes médicas tienen <b>una válidez de 30 días.</b></h2>
				<div class="page-tabs">
		          <a @click.prevent="grid = true" :class="{active: grid}" href="" class="text-uppercase"><i class="fa fa-th-large"></i> Ver Grilla</a>
		          <a @click.prevent="grid = false" :class="{active: !grid}" href="" class="text-uppercase"><i class="fa fa-align-justify"></i> Ver Listado</a>
		        </div>
				<div class="page-content">
					<div v-if="grid">
						<img src="/static/img/coberturas-logos.png" height="2199" width="1131" alt="" class="img-responsive center-block">
					</div>
					<div v-if="!grid" class="color--gray">
						<div class="row">
							<div class="col-sm-4">
								<div v-for="(coverage, index) in coveragesChunk[0]" :key="index">
									{{ coverage }}
								</div>
							</div>
							<div class="col-sm-4">
								<div v-for="(coverage, index) in coveragesChunk[1]" :key="index">
									{{ coverage }}
								</div>
							</div>
							<div class="col-sm-4">
								<div v-for="(coverage, index) in coveragesChunk[2]" :key="index">
									{{ coverage }}
								</div>							
			 				</div>
						</div>
					</div>
				</div>

				<p class="color--gray">
					* Consultar planes y/o servicios incluidos
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import coberturas from './Coverages';

export default {
  name: 'coberturas',
  data() {
  	return {
			grid: true,
			coverages: coberturas,
			coveragesChunk: []
  	}
	},
	methods: {
		chunkedCoverages() {
			const size = this.coverages.length / 3;
			let chunkedArray = [];
			for(let i = 0; i < this.coverages.length; i += size)
				chunkedArray.push(this.coverages.slice(i, i+size));
			this.coveragesChunk = chunkedArray;
		}
	},
	mounted() {
		this.chunkedCoverages();
	}
}
</script>
<!-- styling for the component -->
<style>

</style>


// WEBPACK FOOTER //
// src/components/Coberturas/Coberturas.vue